import XAutoTable from "./XAutoTable";

export default function XAutoDashboard() {
  return <XAutoTable />;
}